import { camelCase } from 'lodash';
import { OrderFields } from '../../../firebase/document-field.enums';
import { OrderFulfillmentStatus } from '../../model/type/order-fulfillment-status.enum';
import { OrderPaymentStatus } from '../../model/type/order-payment-status.enum';
import { OrderStatus } from '../../model/type/order-status.enum';
import { FilterModel } from '../../model/ui/filter.model';
import { FilterType } from '../../model/ui/filter.type';
import { ListSortOption } from '../../model/ui/list-sort-option';
import { OrderListFilterValues } from '../../model/ui/order-list-filter-values';

const FILTERABLE_ORDER_STATUSES = [
  OrderStatus.Created,
  OrderStatus.Submitted,
  OrderStatus.Pending,
  OrderStatus.Processing,
  OrderStatus.Shipped,
  OrderStatus.Fulfilled,
  OrderStatus.Completed,
  OrderStatus.Hold,
  OrderStatus.Canceled,
  OrderStatus.Archived,
  OrderStatus.Failed,
  OrderStatus.WaitingForManualUpdate,
  OrderStatus.Unknown,
];

const toOptions = (values: string[], translationPrefix: string) =>
  values.map((value) => ({
    value,
    label: `${translationPrefix}.${camelCase(value)}`,
    translate: true,
  }));

export const getOrderListFilters = (
  values: OrderListFilterValues
): FilterModel[] => [
  {
    fieldName: OrderFields.internal_id,
    label: 'orders.searchFilters.internalId',
    placeholder: 'orders.searchFilters.internalIdPlaceholder',
    type: FilterType.text,
    value: values.internalId,
  },
  {
    fieldName: OrderFields.user_email,
    label: 'orders.searchFilters.userEmail',
    placeholder: 'orders.searchFilters.userEmailPlaceholder',
    type: FilterType.text,
    value: values.userEmail,
  },
  {
    fieldName: OrderFields.status,
    label: 'orders.searchFilters.orderStatus',
    type: FilterType.select,
    options: toOptions(
      FILTERABLE_ORDER_STATUSES,
      'orders.options.statusOptions'
    ),
    value: values.status,
  },
  {
    fieldName: OrderFields.payment_status,
    label: 'orders.searchFilters.paymentStatus',
    type: FilterType.select,
    options: toOptions(
      Object.values(OrderPaymentStatus),
      'orders.options.paymentStatusOptions'
    ),
    value: values.paymentStatus,
  },
  {
    fieldName: OrderFields.fulfillment_status,
    label: 'orders.searchFilters.fulfillmentStatus',
    type: FilterType.select,
    options: toOptions(
      Object.values(OrderFulfillmentStatus),
      'orders.options.fulfillmentStatusOptions'
    ),
    value: values.fulfillmentStatus,
  },
];

export const getOrderListSortOptions = (
  translate: (key: string) => string
): ListSortOption[] => [
  {
    order_by: 'created_at',
    order_dir: 'desc',
    label: translate('orders.sortOptions.createdNewest'),
  },
  {
    order_by: 'created_at',
    order_dir: 'asc',
    label: translate('orders.sortOptions.createdOldest'),
  },
  {
    order_by: 'ordered_at',
    order_dir: 'desc',
    label: translate('orders.sortOptions.orderedNewest'),
  },
  {
    order_by: 'ordered_at',
    order_dir: 'asc',
    label: translate('orders.sortOptions.orderedOldest'),
  },
  {
    order_by: 'internal_id',
    order_dir: 'asc',
    label: translate('orders.sortOptions.internalIdAscending'),
  },
  {
    order_by: 'internal_id',
    order_dir: 'desc',
    label: translate('orders.sortOptions.internalIdDescending'),
  },
];

export const getListRange = (
  offset: number,
  pageSize: number,
  total: number
): { from: number; to: number } => ({
  from: total === 0 ? 0 : offset + 1,
  to: Math.min(offset + pageSize, total),
});
